<template>
    <client :isSuccess="isSuccess">
        <submission-inputs @on-success="onSuccess" />
        <submission-status  v-if="isSuccess"/>
    </client>
</template>
<script>
import client from "@/components/template/client.vue";
import SubmissionInputs from "@/components/client/Submission/submission-inputs.vue";
import SubmissionStatus from '@/components/client/Submission/submission-status.vue';
export default {
    components: { client, SubmissionInputs, SubmissionStatus },

    data() {
        return {
            isSuccess: false,
        };
    },

    methods: {
        onSuccess() {
            this.isSuccess = true;
        },
    },
};
</script>
